/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/**
 * Use me when dealing with paginated data
 * I can filter out the edges that have a defined node
 *
 * @example
 *   const products = filterEdges(productConnections.edges);
 *             ^ { node: { readonly __typename: "CustomerServiceProduct"; } }[]
 */
export const filterEdges = <T,>(
	edges: readonly { node: T | null | undefined }[] | undefined,
): { node: T }[] =>
	edges?.filter((edge): edge is { node: T } => edge.node !== null && edge.node !== undefined) || [];
